import { getCookie } from '~globals/common';
import constants from '~globals/constants';
import { isSEO } from '~globals/isSeo';
import { useAppSelector } from '~hooks/useRedux';

export default function useAllianceId(isIFP = false) {
    const defaultAllidIFP = constants.DEFAULT_IFP_ALLIANCE_ID;
    const defaultAllidSEO = constants.DEFAULT_SEO_ALLIANCE_ID;
    const defaultAllid = constants.DEFAULT_ALLIANCE_ID;

    const allid = useAppSelector((state) => state.global.allianceId);

    let selectedAllId: string = defaultAllid;

    // USE GLOBAL STATE ALLID
    if (allid) {
        selectedAllId = allid;
    }

    const allidInCookie = getCookie('ehi.alliance_id') as string;
    if (allidInCookie && allidInCookie !== 'ehe12862000') {
        selectedAllId = allidInCookie;
    }

    //SEO values - if the "cameFromSEO" is true, set the alliance id to that
    const cameFromSEO = typeof window !== 'undefined' ? isSEO(document.referrer) : false;
    if (cameFromSEO) {
        selectedAllId = defaultAllidSEO;
    } else if (isIFP) {
        selectedAllId = defaultAllidIFP;
    }

    //URL param - this will always overwrite what's in storage
    const urlParams =
        typeof window !== 'undefined'
            ? Object.fromEntries(new URLSearchParams(window.location.search).entries())
            : {};
    selectedAllId = urlParams.allid || selectedAllId;

    return selectedAllId;
}
